
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '@/components/layout/Layout';
import CompleteContent from '@/components/complete/CompleteContent';
import { QuizProvider } from '@/contexts/QuizContext';

// Complete page that wraps CompleteContent in QuizProvider
const Complete: React.FC = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Check if user has completed the quiz
    const hasCompletedQuiz = localStorage.getItem('hasCompletedQuiz');
    
    // If not, redirect to quiz
    if (!hasCompletedQuiz) {
      navigate('/quiz');
    }
  }, [navigate]);
  
  return (
    <Layout>
      <QuizProvider>
        <CompleteContent />
      </QuizProvider>
    </Layout>
  );
};

export default Complete;
